import LoginPage from "./LoginPage";
import UploadPage from "./UploadPage";
import ViewFilePage from "./ViewFilePage";
import DataTable from "./DataTable";

export { LoginPage, UploadPage, ViewFilePage, DataTable }